import * as React from 'react';
import { connect } from 'react-redux';
import { createRouteNodeSelector } from 'redux-router5';
import { navigate } from '~/router';

import SideMenu from '~/common/menu/SideMenu';


function SideMenuContainer(props) {
  const { route } = props;

  const items = [
    {
      iconClass: 'i-buildings',
      text: 'Organizations',
      isActive: route.name.startsWith('admin.orgs'),
      onClick: (e) => navigate('admin.orgs'),
    },
    {
      iconClass: 'i-cog',
      text: 'Settings',
      isActive: route.name == 'admin.settings',
      onClick: (e) => navigate('admin.settings'),
    },
    {
      iconClass: 'i-logout',
      text: 'Logout',
      isActive: route.name.startsWith('logout'),
      onClick: (e) => navigate('logout'),
    },
  ];

  return (
    <SideMenu items={items} />
  );
}

export default connect(createRouteNodeSelector('admin'))(SideMenuContainer);

